// ============================================================
// API 统一出口
//   页面只从这里 import，数据来源由 config.js 的 DATA_SOURCE 决定：
//     'real' —— 真实后端（backend：Node + Express + MySQL）
//     'mock' —— 本地假数据（离线演示）
//   两套实现函数签名、返回结构完全一致，页面代码无需改动。
//
//   说明：个人中心相关接口（getUser/createHelp/... ）暂未接入真实后端，
//         real 模式下会自动回落到 mock 实现，待逐个替换。
// ============================================================
import { DATA_SOURCE } from './config'
import * as mock from './mock'
import * as real from './real'

const api = DATA_SOURCE === 'mock' ? { ...real, ...mock } : { ...mock, ...real }

export const {
  // 登录态
  getCurrentUser,
  requireLogin,
  // 公共
  getLable,
  getCarousels,
  // 列表
  getHelpList,
  getActivityList,
  getJobList,
  getArticleList,
  getOldstuffList,
  getCompanyList,
  // 详情
  getHelpContent,
  getActivityContent,
  getJobContent,
  getArticleContent,
  getOldstuffContent,
  getCompanyContent,
  getAnnouncementList,
  // 报名 / 意向
  setJoin,
  // 搜索
  searchAll,
  // 评论 / 回复
  getComment,
  setComment,
  getReply,
  setReply,
  // 消息通知
  getNotice,
  changeNotice,
  // 注册 / 登录
  registered,
  login,
  logout,
  // 个人中心（暂用 mock 实现，待接入真实后端）
  getUser,
  updateUser,
  getUserNumbering,
  getMyHelpList,
  getHelpDetails,
  createHelp,
  updateHelp,
  deleteHelp,
  getMyActivityList,
  getActivityDetails,
  createActivity,
  updateActivity,
  deleteActivity,
  getMyJoins,
  getJoinsList,
  deleteJoin,
  setAnnouncement,
  getMyOldstuffList,
  getOldstuffDetails,
  createOldstuff,
  updateOldstuff,
  deleteOldstuff,
  getMyArticleList,
  getArticleDetails,
  createArticle,
  updateArticle,
  deleteArticle,
  getWebCompany,
  changeWebCompany,
  createJob,
  deleteJob,
  // 客服中心
  createFankui,
  createJubao,
  getJubaoContent,
  createShensu
} = api
